import { createFileRoute } from "@tanstack/react-router";
import Careers from "@/pages/Careers";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/careers")({
  head: () =>
    seo({
      title: "Careers | Join the Cedar Creek Construction Crew",
      description:
        "Hiring roofers, siding installers, and exterior construction crew in Minnesota. Competitive pay, growth opportunities, and a tight-knit team.",
      path: "/careers",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Careers", path: "/careers" },
      ]),
    }),
  component: Careers,
});
